<template>
    <div class="alert-success"
        v-show="show"
    >
        {{ body }}
        <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            @click="hideMessage()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

</template>

<script>
    export default {
        props: ['message'],
        data() {
            return {
                show : false,
                body : ''
            }
        },
        created() {
            if(this.message) {
                this.flash(this.message)
            }
            window.events.$on('flash',(message) => this.flash(message))
        },
        methods: {
            flash(message) {
                this.show = true
                this.body = message
                $('#app').addClass('flash')
            },

            hide() {
                this.show = false
                $('#app').addClass('flash')
            },

            hideMessage() {
                this.show = false
                $('#app').removeClass('flash')
            }
        }
    }
</script>

<style scoped>
    .alert-success {
        width: 100vw;
        min-height: 50px;
        color: #155724;
        background-color: #d4edda;
        border-color: #c3e6cb;
        position: fixed;
        border: 1px solid transparent;
        top: 0px;
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
    }
    .close {
        position: absolute;
        top: 0px;
        right: 6px;
        padding: .75rem 1.25rem;
        color: inherit;
        background-color: transparent;
        border: 0;
        float: right;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
        text-shadow: 0 1px 0 #fff;
        opacity: .5;
    }

    @media screen and (max-width: 768px) {
        .close {
            right: -14px;
        }

        .alert-success {
            padding: 5px 20px 5px 10px;
            font-size: 14px;
            line-height: 18px;
        }
    }
</style>
<style>
    #app.flash {
        display: block;
        padding-top: 50px;
    }

    @media screen and (max-width: 768px) {
        #app.flash #target{
            top: 60px;
        }
    }

</style>